import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { TiktokBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createTiktokBlock = (props: Props): TiktokBlockProps => {
  return {
    type: 'tiktok',
    value: props.label,
    width: 20,
    height: 20,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    ...props,
  };
};

export function isTiktokBlock(block: BlockProps): block is TiktokBlockProps {
  return block.type === 'tiktok';
}
